export const color1 = "rgb(34,177,76)";
export const color1Label = "Substantial";

export const color2 = "rgb(255,201,14)";
export const color2Label = "Moderate";

export const color3 = "rgb(255,127,39)";
export const color3Label = "Limited";

export const color4 = "rgb(237,28,36)";
export const color4Label = "Unsatisfactory";

export const color5 = "rgb(0,162,232)";
export const color5Label = "Not Applicable";

export const barDefaultBackgroundColor = "rgb(200,200,200)";
